import { useQuery } from '@apollo/client';
import React, { useContext } from 'react';
import { InquiryPreviewInput } from 'sr-types/lib/shortlist/v1/graphql';
import { UserContext } from '../common/auth/UserContext';
import Loading from '../common/components/Loading';
import { StepsIndexConstant } from '../common/components/Stepper';
import { useStepper } from '../common/components/StepperContext';
import { FETCH_POLICY_CONFIG } from '../common/constants/constants';
import { RESOURCE_TYPE } from '../resource/common/resourceConstants';
import { ORGANIZATION_TYPE, PEOPLE_TYPE, getInquiryPreviewInput } from '../shortlists/form/inquiry/inquiry';
import InquiryPreviewForm from '../shortlists/form/inquiry/InquiryPreviewForm';
import { client, inquiryPreviewQuery } from '../shortlists/shortlist';

export default ({ resType }: { resType: string }) => {
    const { getStepData } = useStepper();
    const isPeopleType = [RESOURCE_TYPE.crew, RESOURCE_TYPE.cast, RESOURCE_TYPE.corporate].includes(resType);
    const type = isPeopleType ? PEOPLE_TYPE : ORGANIZATION_TYPE;

    const requestAvailsData = getStepData(isPeopleType ? StepsIndexConstant.two : StepsIndexConstant.three);

    const inquiryPreviewInput: InquiryPreviewInput = getInquiryPreviewInput(
        type,
        requestAvailsData,
        requestAvailsData?.[type]?.[0] ?? null
    );

    const { activeOrganizationAccount } = useContext(UserContext);
    const { data: previewData, loading: isPreviewLoading } = useQuery(inquiryPreviewQuery, {
        variables: { inquiryInput: inquiryPreviewInput },
        client,
        context: {
            headers: {
                ownerId: activeOrganizationAccount
            }
        },
        fetchPolicy: FETCH_POLICY_CONFIG.apolloFetchPolicy
    });

    return isPreviewLoading ? (
        <Loading />
    ) : (
        previewData && (
            <InquiryPreviewForm type={type} previewData={previewData?.inquiryPreview} state={requestAvailsData} />
        )
    );
};
